import { useState } from 'react';
import { useForm } from 'react-hook-form';

const ContactForm = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const [disabled, setDisabled] = useState(false);
    const [alertInfo, setAlertInfo] = useState({
        display: false,
        message: '',
        type: '',
    });

    const submitMe = async (data) => {
        // Destructure data object
        const { name, email, message } = data;

        try {
            // Disable form while processing submission
            setDisabled(true);

            let details = {
                name: name,
                email: email,
                message: message,
            }
            let response = await fetch("/api/contact", {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
              body: JSON.stringify(details),
            })
        } finally {
            // Re-enable form submission
            setDisabled(false);
            // Reset contact form fields after submission
            reset();
        }
    };

    return (
        <div className="entry-content">
            <div className="wp-block-group alignfull has-background-light-background-color has-background">
                <div className="wp-block-columns alignfull is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                        <div className="wp-block-jetpack-contact-form-container ">
                            <form className="contact-form" onSubmit={handleSubmit(submitMe)} noValidate>
                                <div className="wp-block-jetpack-contact-form">
                                    <div className="grunion-field-name-wrap grunion-field-wrap">
                                        <label className="grunion-field-label name">Nom</label>
                                        <input
                                            type="text"
                                            name="name"
                                            {...register('name', {
                                                required: {
                                                  value: true,
                                                  message: 'Please enter your name',
                                                },
                                                maxLength: {
                                                  value: 30,
                                                  message: 'Please use 30 characters or less',
                                                },
                                            })}
                                            className="name grunion-field"/>
                                            {errors.name && (
                                                <span className='errorMessage'>
                                                    {errors.name.message}
                                                </span>
                                            )}
                                    </div>
                                    <div className="grunion-field-email-wrap grunion-field-wrap">
                                        <label className="grunion-field-label email">Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            {...register('email', {
                                                required: true,
                                                pattern:
                                                  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                            })}
                                            className="email grunion-field"/>
                                        {errors.email && (
                                            <span className='errorMessage'>
                                                Please enter a valid email address
                                            </span>
                                        )}
                                    </div>
                                    <div className="grunion-field-textarea-wrap grunion-field-wrap no-label">
                                        <label className="grunion-field-label textarea">Message</label>
                                        <textarea
                                            name="message"
                                            name='message'
                                            {...register('message', {
                                                required: true,
                                            })}
                                            className="textarea grunion-field"/>
                                        {errors.message && (
                                            <span className='errorMessage'>
                                                Please enter a message
                                            </span>
                                        )}
                                    </div>
                                    <div className="wp-block-jetpack-button wp-block-button">
                                        <input type="submit" value="Envoyer" className="wp-block-button__link"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;